export default "__VITE_ASSET__BlCifKwo__"